export const CORRECTED_KEYWORD_FOR_UNDO = 'corrected_keyword_for_undo';
export const CORRECTED_KEYWORD_FOR_REDO = 'corrected_keyword_for_redo';
